import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconActivity,
  IconCalendar,
  IconCheck,
  IconDots,
  IconEdit,
  IconEye,
  IconHandStop,
  IconPlus,
  IconSearch,
  IconStatusChange,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getProvinceSelectNew,
  getTblDmEmployeeAll,
} from "../../../service/getSelectApi";
import DeleteView from "./DeleteView";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ListVoucher = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    StartDate: _searchJson && checkedPinSearch ? _searchJson?.StartDate : "",
    EndDate: _searchJson && checkedPinSearch ? _searchJson?.EndDate : "",
    Active: _searchJson && checkedPinSearch ? _searchJson?.Active : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "vourcherCode",
        header: "Mã voucher",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              color={renderedCellValue ? "green" : "red"}
              onDoubleClick={() => handleCheckDetailVoucher(row.original.id)}
            >
              {renderedCellValue ? renderedCellValue : "Không xác định"}
            </Badge>
          </Tooltip>
        ),
      },
      { accessorKey: "vourcherName", header: "Tên voucher" },
      {
        accessorKey: "vourcherValue",
        header: "Giá trị voucher",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || Number(renderedCellValue) === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()}{" "}
              {String(row.original.voucherType) === "1"
                ? "VNĐ"
                : String(row.original.voucherType) === "2"
                  ? "%"
                  : "đơn vị theo loại vourcher"}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "minOrderAmount",
        header: "Giá trị đơn hàng tối thiểu áp dụng",
        size: 300,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || Number(renderedCellValue) === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "maxOrderAmount",
        header: "Đơn hàng tối đa áp dụng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
        size: 250,
      },
      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue ? "green" : "red"}>
            {renderedCellValue ? "Hoạt động" : "Không hoạt động"}
          </Badge>
        ),
      },
      {
        accessorKey: "startDate",
        header: "Ngày có hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "expiredDate",
        header: "Ngày hết hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      // {
      //   accessorKey: "usedDate",
      //   header: "Ngày sử dụng",
      //   Cell: ({ renderedCellValue }: any) => (
      //     <Text size="12.5px" fw={"500"}>
      //       {renderedCellValue && formatDateTransfer(renderedCellValue)}
      //     </Text>
      //   ),
      // },
      {
        accessorKey: "voucherQuantity",
        header: "Số lượng voucher",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === "n" ? "Không giới hạn" : renderedCellValue}
          </Text>
        ),
      },
      { accessorKey: "usedCount", header: "Số lượng đã dùng" },
      {
        accessorKey: "useForPos",
        header: "Sử dụng cho POS",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={
              !renderedCellValue || Number(renderedCellValue) === 0
                ? "red"
                : "green"
            }
          >
            {!renderedCellValue || Number(renderedCellValue) === 0
              ? "Không được sử dụng"
              : "Được sử dụng"}
          </Badge>
        ),
      },
      {
        accessorKey: "useForWeb",
        header: "Sử dụng cho Web",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={
              !renderedCellValue || Number(renderedCellValue) === 0
                ? "red"
                : "green"
            }
          >
            {!renderedCellValue || Number(renderedCellValue) === 0
              ? "Không được sử dụng"
              : "Được sử dụng"}
          </Badge>
        ),
      },
      {
        accessorKey: "useOneTime",
        header: "Chỉ được áp dụng 1 voucher/1 KH",
        size: 287.5,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={
              !renderedCellValue || Number(renderedCellValue) === 0
                ? "red"
                : "green"
            }
          >
            {!renderedCellValue || Number(renderedCellValue) === 0
              ? "Không được sử dụng"
              : "Được sử dụng"}
          </Badge>
        ),
      },
      {
        accessorKey: "branchIds",
        header: "Chi nhánh áp dụng",
        size: 550,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Flex gap={"xs"} align={"center"}>
              {String(renderedCellValue)
                ?.split(",")
                ?.filter((item: any) => item !== "-1")
                ?.slice(0, 3)
                ?.map((item: any) => (
                  <Badge variant="light" color="green">
                    {getValueById(item, dataBranchSelect, "label")}
                  </Badge>
                ))}
              {String(renderedCellValue)?.split(",")?.length > 3 ? (
                <Menu width={500}>
                  <Menu.Target>
                    <Tooltip label="Xem thêm">
                      <ActionIcon variant="light" radius={"lg"} color="green">
                        <IconDots size={18} />
                      </ActionIcon>
                    </Tooltip>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Flex
                      gap={"xs"}
                      wrap={"wrap"}
                      justify={"center"}
                      w={"100%"}
                    >
                      {String(renderedCellValue)
                        ?.split(",")
                        ?.filter((item: any) => item !== "-1")
                        ?.slice(
                          3,
                          Number(
                            String(renderedCellValue)
                              ?.split(",")
                              ?.filter((item: any) => item !== "-1")?.length,
                          ),
                        )
                        ?.map((item: any) => (
                          <Badge variant="light" color="green">
                            {getValueById(item, dataBranchSelect, "label")}
                          </Badge>
                        ))}
                    </Flex>
                  </Menu.Dropdown>
                </Menu>
              ) : (
                <></>
              )}
            </Flex>
          ) : (
            <Badge color="blue" variant="light">
              Tất cả
            </Badge>
          ),
      },
      // {
      //   accessorKey: "provinceIds",
      //   header: "Tỉnh thành giao hàng",
      //   size: 550,
      //   Cell: ({ renderedCellValue }) =>
      //     renderedCellValue ? (
      //       <Flex gap={"xs"} align={"center"}>
      //         {String(renderedCellValue)
      //           ?.split(",")
      //           ?.filter((item: any) => item !== "-1")
      //           ?.slice(0, 3)
      //           ?.map((item: any) => (
      //             <Badge variant="light" color="green">
      //               {getValueById(item, dataProvinceSelect, "label")}
      //             </Badge>
      //           ))}
      //         {String(renderedCellValue)?.split(",")?.length > 3 ? (
      //           <Menu width={500}>
      //             <Menu.Target>
      //               <Tooltip label="Xem thêm">
      //                 <ActionIcon variant="light" radius={"lg"} color="green">
      //                   <IconDots size={18} />
      //                 </ActionIcon>
      //               </Tooltip>
      //             </Menu.Target>
      //             <Menu.Dropdown>
      //               <Flex
      //                 gap={"xs"}
      //                 wrap={"wrap"}
      //                 justify={"center"}
      //                 w={"100%"}
      //               >
      //                 {String(renderedCellValue)
      //                   ?.split(",")
      //                   ?.filter((item: any) => item !== "-1")
      //                   ?.slice(
      //                     3,
      //                     Number(
      //                       String(renderedCellValue)
      //                         ?.split(",")
      //                         ?.filter((item: any) => item !== "-1")?.length
      //                     )
      //                   )
      //                   ?.map((item: any) => (
      //                     <Badge variant="light" color="green">
      //                       {getValueById(item, dataProvinceSelect, "label")}
      //                     </Badge>
      //                   ))}
      //               </Flex>
      //             </Menu.Dropdown>
      //           </Menu>
      //         ) : (
      //           <></>
      //         )}
      //       </Flex>
      //     ) : (
      //       <Badge color="blue" variant="light">
      //         Tất cả
      //       </Badge>
      //     ),
      // },
      {
        accessorKey: "enforcement",
        header: "Hiệu lực",
        Cell: ({ row }) => (
          <Badge
            color={
              !row.original.expiredDate
                ? row.original.active &&
                  new Date(row.original.startDate) < new Date()
                  ? "green"
                  : "gray"
                : row.original.active &&
                    new Date(row.original.startDate) < new Date() &&
                    new Date(row.original.expiredDate) > new Date()
                  ? "green"
                  : "gray"
            }
          >
            {!row.original.expiredDate
              ? row.original.active &&
                new Date(row.original.startDate) < new Date()
                ? "Đang có hiệu lực"
                : "Không có hiệu lực"
              : row.original.active &&
                  new Date(row.original.startDate) < new Date() &&
                  new Date(row.original.expiredDate) > new Date()
                ? "Đang có hiệu lực"
                : "Không có hiệu lực"}
          </Badge>
        ),
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdateBy",
        header: "Người cập nhật cuối",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật cuối",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Flex justify={"start"} align={"center"} gap={"xs"}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="orange"
                onClick={() =>
                  navigate("/category-data/edit-vourcher", {
                    state: {
                      id: row.original.id,
                    },
                  })
                }
              >
                <IconEdit size={18} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label={row.original.active ? "Không sử dụng" : "Sử dụng"}>
              {row.original.active ? (
                <ActionIcon
                  variant="light"
                  color="violet"
                  onClick={() => handleActivity([row.original.id])}
                  disabled={
                    !row.original.expiredDate
                      ? new Date(row.original.startDate) < new Date()
                        ? false
                        : true
                      : new Date(row.original.startDate) < new Date() &&
                          new Date(row.original.expiredDate) > new Date()
                        ? false
                        : true
                  }
                >
                  <IconHandStop size={18} />
                </ActionIcon>
              ) : (
                <ActionIcon
                  variant="light"
                  color="green"
                  onClick={() => handleActivity([row.original.id])}
                  disabled={
                    !row.original.expiredDate
                      ? new Date(row.original.startDate) < new Date()
                        ? false
                        : true
                      : new Date(row.original.startDate) < new Date() &&
                          new Date(row.original.expiredDate) > new Date()
                        ? false
                        : true
                  }
                >
                  <IconActivity size={18} />
                </ActionIcon>
              )}
            </Tooltip>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() =>
                  navigate("/category-data/detail-vourcher", {
                    state: {
                      id: row.original.id,
                    },
                  })
                }
              >
                <IconEye size={18} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={() => modalsDeleteVourcher([row.original.id])}
              >
                <IconTrash size={18} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataEmployee, dataBranchSelect, dataProvinceSelect],
  );

  const handleCheckDetailVoucher = (id: string | number) => {
    navigate("/category-data/detail-vourcher", {
      state: {
        id: id,
      },
    });
  };

  const optionStatus: Record<"Sử dụng" | "Không sử dụng", string> = {
    "Sử dụng": "green",
    "Không sử dụng": "red",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={optionStatus[option.label as "Sử dụng" | "Không sử dụng"]}
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const modalsDeleteVourcher = (listId: number[]) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xóa vourcher</Title>,
      size: "auto",
      children: <DeleteView listId={listId} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblVoucherDetail/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params?.toString()}`;

      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
  };

  // const exportDataExcel = async () => {
  //   open();
  //   try {
  //     let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //     const params = new URLSearchParams();
  //     Object.entries(search).forEach(([key, value]) => {
  //       if (Array.isArray(value) && value.length > 0) {
  //         value.forEach((item) => params.append(key, String(item)));
  //       } else if (typeof value === "string" && value.length > 0) {
  //         params.append(key, value);
  //       }
  //     });

  //     if (keySearch.length > 0) {
  //       url += `&KeySearch=${keySearch?.trim()}`;
  //     }

  //     url += `&${params.toString()}`;

  //     const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

  //     const _url = BASE_API_MDM + baseUrl;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "danh_sach_voucher.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const handleActivity = async (listId: number[]) => {
    const res = await repositoryPos.put<MessageResponse<any>>(
      "/api/v1/TblVoucherDetail/active",
      { ids: listId },
    );

    if (res && res.success) {
      NotificationExtension.Success("Đổi trạng thái thành công !");
      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.value),
        }));
      setDataBranchSelect(data);
    }
  };

  const getDataProvinceSelect = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([
      fetchDataEmp(),
      getDataBranchSelect(),
      getDataProvinceSelect(),
    ]);
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningListVourcher",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers", "vourcherCode"],
          right: ["enforcement", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningListVourcher",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconStatusChange size={16} />}
              color="blue"
              onClick={() =>
                handleActivity(selectIds?.map((item) => Number(item)))
              }
              disabled={selectIds.length === 0}
            >
              Đổi trạng thái
            </Button>
            <Button
              leftSection={<IconTrash size={16} />}
              color="red"
              onClick={() =>
                modalsDeleteVourcher(selectIds?.map((item) => Number(item)))
              }
              disabled={selectIds.length === 0}
            >
              Xóa nhiều vourcher
            </Button>
            <Button
              leftSection={<IconPlus size={16} />}
              color="green"
              onClick={() => navigate("/category-data/create-vourcher")}
            >
              Thêm mới
            </Button>
            {/* <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.StartDate && search.StartDate?.length > 0
                  ? new Date(search.StartDate ?? "")
                  : null
              }
              maxDate={
                search.EndDate && search.EndDate?.length > 0
                  ? new Date(search.EndDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "StartDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.EndDate && search.EndDate?.length > 0
                  ? new Date(search.EndDate ?? "")
                  : null
              }
              minDate={
                search.StartDate && search.StartDate?.length > 0
                  ? new Date(search.StartDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "EndDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái"
              leftSection={<IconStatusChange color="#15aabf" />}
              data={[
                { label: "Sử dụng", value: "true" },
                { label: "Không sử dụng", value: "false" },
              ]}
              value={search?.Active}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "Active", setSearch)
              }
              clearable
              renderOption={renderSelectOptionStatus}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ListVoucher;
